module.exports = __webpack_public_path__ + "static/img/menageService4.466b2f5e.png";